export enum InternalDataSource {
  BUSINESS_ENTITY_BY_ID = 'BUSINESS_ENTITY_BY_ID',
  DIRECTOR_BY_ID = 'DIRECTOR_BY_ID',
  WORK_REQUEST_BY_ID = 'WORK_REQUEST_BY_ID',
}
